import React from "react"
import { Card, CardBody, Col, Input, Label, Row } from "reactstrap"
import Switch from "react-switch"

function VenueFoodBooking({
  validation,
  toggleSection = () => { },
  openSection,
  addFoodItem,
  removeFoodItem,
}) {
  const isFoodTypeSelected =
    validation.values.enable_veg ||
    validation.values.enable_nonveg ||
    validation.values.enable_vegan

  return (
    <>

      <div className="card border-0 shadow-sm p-3 mb-3">
        <div className="d-flex justify-content-between align-items-center">
          <span className="fw-semibold">Enable Food</span>

          <Switch
            checked={!!validation.values.enable_food}
            onChange={checked =>
              validation.setFieldValue("enable_food", checked)
            }
            onColor="#34c38f"
            offColor="#b3a692"
            uncheckedIcon={false}
            checkedIcon={false}
            height={16}
            width={32}
            handleDiameter={14}
          />
        </div>
      </div>

      {validation.values.enable_food && (
        <div className="ms-2">
          <div className="p-4 mb-3 rounded border border-warning bg-warning bg-opacity-10">
            <h6 className="fw-bold mb-3">Food Options</h6>

            <div className="d-flex flex-wrap gap-4 mb-3">
              <div
                className="form-check"
                onClick={e => e.stopPropagation()}
              >
                <Input
                  type="checkbox"
                  className="form-check-input me-2"
                  id="enable_veg"
                  defaultChecked={validation.values.enable_veg}
                  onChange={e =>
                    validation.setFieldValue(
                      "enable_veg",
                      e.target.checked
                    )
                  }
                />
                <Label className="mb-0" htmlFor="enable_veg">
                  Veg
                </Label>
              </div>

              <div
                className="form-check "
                onClick={e => e.stopPropagation()}
              >
                <Input
                  type="checkbox"
                  className="form-check-input me-2"
                  id="enable_nonveg"
                  defaultChecked={validation.values.enable_nonveg}
                  onChange={e =>
                    validation.setFieldValue(
                      "enable_nonveg",
                      e.target.checked
                    )
                  }
                />
                <Label className="mb-0" htmlFor="enable_nonveg">
                  Non-Veg
                </Label>
              </div>
              <div
                className="form-check "
                onClick={e => e.stopPropagation()}
              >
                <Input
                  type="checkbox"
                  className="form-check-input me-2"
                  id="enable_vegan"
                  defaultChecked={validation.values.enable_vegan}
                  onChange={e =>
                    validation.setFieldValue(
                      "enable_vegan",
                      e.target.checked
                    )
                  }
                />
                <Label className="mb-0" htmlFor="enable_vegan">
                  Vegan
                </Label>
              </div>
            </div>
            <div>
              <div
                className="form-check form-switch  "
                onClick={e => e.stopPropagation()}
              >
                <Input
                  type="switch"
                  className="form-check-input"
                  id="enable_food_menu"
                  name="enable_food_menu"
                  defaultChecked={
                    !!validation.values.enable_food_menu
                  }
                  onChange={validation.handleChange}
                  style={{ transform: "scale(1.5)" }}
                />
                <label className="ms-2">Enable Food Menu</label>
              </div>
            </div>
            {isFoodTypeSelected && (
              <div className="">

                {validation.values.enable_food_menu && (
                  <div className="p-4 mb-3 rounded border border-success bg-success bg-opacity-10">
                    <Row className="g-4 mb-2 fw-semibold">
                      <Col md={3}>Food Type</Col>
                      <Col md={3}>Item Name</Col>
                      <Col md={4}>Description</Col>
                      <Col md={2}></Col>
                    </Row>
                    {validation.values.food_items.map(
                      (item, index) => (
                        <div
                          key={index}
                          className="p-2 mb-2 rounded bg-light border-0"
                        >
                          <Row className="g-2 align-items-center">
                            <Col md={3}>
                              <Input
                                type="select"
                                name={`food_items[${index}].category`}
                                value={item.category}
                                onChange={validation.handleChange}
                              >
                                {[
                                  validation.values.enable_veg &&
                                  "Veg",
                                  validation.values.enable_nonveg &&
                                  "Non-Veg",
                                  validation.values.enable_vegan &&
                                  "Vegan",
                                ]
                                  .filter(Boolean)
                                  .map(option => (
                                    <option
                                      key={option}
                                      value={option}
                                    >
                                      {option}
                                    </option>
                                  ))}
                              </Input>
                            </Col>

                            <Col md={3}>
                              <Input
                                type="text"
                                placeholder="Item Name"
                                name={`food_items[${index}].itemName`}
                                value={item.itemName}
                                onChange={validation.handleChange}
                              />
                            </Col>

                            <Col md={4}>
                              <Input
                                type="text"
                                placeholder="Description"
                                name={`food_items[${index}].description`}
                                value={item.description}
                                onChange={validation.handleChange}
                              />
                            </Col>

                            <Col md={2} className="text-end">
                              <button
                                type="button"
                                className="btn btn-link text-danger p-0"
                                onClick={() => removeFoodItem(index)}
                              >
                                <i className="mdi mdi-delete-outline fs-5"></i>
                              </button>
                            </Col>
                          </Row>
                        </div>
                      )
                    )}
                    <button
                      type="button"
                      className="btn btn-outline-dark btn-sm mt-1"
                      // onClick={addFoodItem}
                      onClick={() => {
                        const foodItems =
                          validation.values.food_items || []

                        if (foodItems.length === 0) {
                          addFoodItem()
                          return
                        }

                        const hasEmptyItem = foodItems.some(item => {
                          const category = item.category
                          const itemName = item.itemName?.trim()
                          const description = item.description?.trim()

                          return (
                            !category || !itemName || !description
                          )
                        })

                        if (hasEmptyItem) {
                          alert(
                            "Please complete all existing food items before adding another."
                          )
                          return
                        }

                        addFoodItem()
                      }}
                    >
                      <i className="mdi mdi-plus-circle-outline me-1"></i>{" "}
                      Add Item
                    </button>
                  </div>
                )}{" "}
              </div>
            )}
          </div>


        </div>
      )}
    </>
  )
}

export default VenueFoodBooking
